import { logWrapper } from '../../utils';

export default {
  nfeListController: [
    'runtimeConstant',
    '$scope',
    'authService',
    function (runtimeConstant, $scope, authService) {
      'use strict';

      function isSysAdmin() {
        return authService.isSysAdmin();
      }

      function isLoading() {
        return $scope.loading || !authService.user.email;
      }

      function loadMore() {
        $scope.totalDisplayed += 50;
      }

      function run() {
        try {
          $scope.totalDisplayed = 50;

          $scope.isSysAdmin = logWrapper(
            isSysAdmin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isLoading = logWrapper(
            isLoading,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadMore = logWrapper(
            loadMore,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
